/* eslint-disable react/jsx-indent-props */
import React, { useState, useEffect } from "react";
import Layout from "../components/layout";
import { observer } from "mobx-react-lite";
import { useStores } from "../use.store";
import { shallowEqual, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import HeaderComponent from "../components/HeaderComponent";
import email from "../assets/images/email.svg";
import call from "../assets/images/call.svg";
import visit from "../assets/images/visit.svg";

const GetInfo = observer(() => {
  const { generalStore } = useStores();
  const [filteredData, setFilteredData] = useState([]);

  const { config } = useSelector((state) => {
    return {
      config: state.auth.config,
    };
  }, shallowEqual);

  useEffect(() => {
    generalStore.activePage = "get-info";
  }, []);

  const handleAnalytics = (label, callback) => {
    // axios
    //   .post(`${config.baseUrl}/analytic/application`, {
    //     site: config.siteId,
    //     device: config.map.deviceId,
    //     type: "gethelp",
    //     action: "select",
    //     label: label,
    //   })
    //   .finally(callback);
  };

  const listMenu = [
    {
      name: "Operating Hours of State Courts",
      image: "clock",
      slug: "operating-hours",
      informationId: "672da8d0f5c87d7d52b148a0",
    },
    {
      name: "Contact Details",
      image: "contact",
      slug: "contact-details",
      informationId: "6731c4db550562c63c031941",
    },
    {
      name: "Lobby and Escalators Operating Guide",
      image: "escalator",
      slug: "lobby-operating-guide",
      informationId: "6731c4cf550562c63c03193a",
    },
  ];

  const navigate = useHistory();

  return (
    <Layout>
      <div className="h-full w-full flex flex-col">
        <HeaderComponent title={"Get Info"} />

        {/* body */}
        <div className="flex-grow w-full flex flex-col items-center overflow-y-scroll p-4 md:gap-6 md:py-6 bg-whiteBg md:px-28">
          <span className="py-4 text-2xl text-[#50555C] font-bold">
            Information Center
          </span>

          {/* Email */}
          <div className="flex flex-row gap-4 bg-white p-4 rounded-md items-center w-full mb-4">
            <img src={email} className="w-6 h-6 md:w-10 md:h-10" />
            <p>
              <span className="text-xs md:text-sm text-[#959595]">Email</span>
              <br />
              <a target="_blank" className="text-base md:text-2xl font-bold">
                contactus@sgenable.sg
              </a>
            </p>
          </div>

          {/* Call */}
          <div className="flex flex-row gap-4 bg-white p-4 rounded-md items-center w-full mb-4">
            <img src={call} className="w-6 h-6 md:w-10 md:h-10" />
            <p>
              <span className="text-xs md:text-sm text-[#959595]">Call</span>
              <br />
              <a target="_blank" className="text-base md:text-2xl font-bold">
                1800-8585-885
              </a>
              <br />
              <p className="text-[10px] text-[#959595] leading-3">
                (Operating hours: 9.00am-5.30pm on weekdays, closed on weekends
                and public holidays)
              </p>
            </p>
          </div>

          {/* Visit */}
          <div className="flex flex-row gap-4 bg-white p-4 rounded-md items-center w-full mb-4">
            <img src={visit} className="w-6 h-6 md:w-10 md:h-10" />
            <p>
              <span className="text-xs md:text-sm text-[#959595]">Visit</span>
              <br />
              <a target="_blank" className="text-base md:text-2xl font-bold">
                20 Lengkok Bahru (Enabling Village) #01-01 Singapore 159053
              </a>
              <br />
              <p className="text-[10px] text-[#959595] leading-3">
                Weekdays: 9am to 5.30pm Closed on weekends and public holidays
                Shuttle bus services are available
              </p>
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
});

export default GetInfo;
